import {NavLink, useHistory} from "react-router-dom";
import {Bookmark, Briefcase, Home, Lock, LogOut, Mail, Menu as MENU, Send, User, Users, X} from "react-feather";
import {memo, useCallback, useEffect, useState} from "react";
import toast from "../../utils/swalToast";
import {LuUserCog} from "react-icons/lu";
import {VscCompassActive} from "react-icons/vsc";
import {LiaStackExchange} from "react-icons/lia";
import {AiOutlineComment} from "react-icons/ai";
import {MdKeyboardDoubleArrowLeft} from "react-icons/md";

const SideMenuBar = memo(({mobileShow, onClose}) => {
    const history = useHistory();
    const [userInfo, setUserInfo] = useState({
        Avatar: "", FirstName: "",
    });
    const [isUserLoading, setIsUserLoading] = useState(false)

    const loadUserInfo = async () => {
        await setUserInfo({FirstName: localStorage.getItem("UserName"), Avatar: localStorage.getItem("Avatar")})
    }
    
    useEffect(() => {
        if (!localStorage.getItem("UserId")) {
            history.push('/');
        } else {
            loadUserInfo();
        }
    }, []);

    // Close menu when clicking outside on mobile
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (mobileShow && window.innerWidth <= 768) {
                const sidebar = document.querySelector('.sidebar-menu-container');
                if (sidebar && !sidebar.contains(event.target) && !event.target.closest('.btn_dashboard_menu')) {
                    onClose && onClose();
                }
            }
        };

        if (mobileShow) {
            document.addEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = 'hidden'; // Prevent background scrolling
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = 'auto';
        };
    }, [mobileShow, onClose]);

    return (<div className={`sidebar-menu-container ${mobileShow ? "show" : "hide"}`}>

        <div className='sidebar-menu' data-aos='fade-right'>
            <button className='btn-back-dashboard' onClick={() => {
                history.push('/');
            }}><MdKeyboardDoubleArrowLeft/> Back To Dashboard
            </button>
            <div className="sidebar-userblock">
                <img
                    src={userInfo.Avatar ? userInfo.Avatar : "https://static.vecteezy.com/system/resources/previews/020/911/740/non_2x/user-profile-icon-profile-avatar-user-icon-male-icon-face-icon-profile-icon-free-png.png"}
                    alt="User Image"/>
                <h4 className="username">{userInfo.FirstName}</h4>
            </div>
            <div className="sidebar-menu-items">
                <ul>
                    <li>
                        <NavLink to={'/user/dashboard'} exact>
                            <Home/> Dashboard
                        </NavLink>
                    </li>
                    <li>

                        <NavLink to={'/user/profile'} exact>
                            <User/> My Profile</NavLink>
                    </li>
                    <li>
                        <NavLink to={'/user/active-appointments'} exact>
                            <VscCompassActive/> Active Appointments
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={'/user/past-appointments'} exact>
                            <LiaStackExchange/> Past Appointments
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={'/user/change-password'} exact>
                            <Lock/> Change Password
                        </NavLink>
                    </li>
                    <li>
                        <button 
                            type="button"
                            onClick={() => {
                                document.cookie = "UserId=" + null;
                                document.cookie = "UserName=" + null;
                                document.cookie = "Type=" + null;
                                document.cookie = "Company=" + null;
                                localStorage.removeItem("UserId");
                                localStorage.removeItem("UserName");
                                localStorage.removeItem("Type");
                                localStorage.removeItem("Company");
                                history.push("/");
                            }}
                            style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, font: 'inherit', width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', gap: '8px' }}
                        >
                            <LogOut/> Logout
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>)
})
export default SideMenuBar;
